import custKnownWayReportNoStrain from './custKnownWayReportNoStrain'
export default custKnownWayReportNoStrain
